<script setup lang="ts">
import { Check } from 'lucide-vue-next'
import { SelectItem, SelectItemIndicator, type SelectItemProps, SelectItemText, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<SelectItemProps & { class?: HTMLAttributes['class']; disabled?: boolean }>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

// eslint-disable-next-line unicorn/prevent-abbreviations
const forwardedProps = useForwardProps(delegatedProperties)
</script>

<template>
  <SelectItem v-bind="forwardedProps" :class="cn('atabix-select-item', props.class)" :disabled="disabled">
    <span class="atabix-select-item__span">
      <SelectItemIndicator>
        <Check class="atabix-select-item__span-check" />
      </SelectItemIndicator>
    </span>

    <SelectItemText>
      <slot />
    </SelectItemText>
  </SelectItem>
</template>

<style lang="scss">
.atabix-select-item {
  @apply relative;
  @apply flex;
  @apply w-full;
  @apply cursor-default;
  @apply select-none;
  @apply items-center;
  @apply rounded-sm;
  @apply py-1.5;
  @apply pl-8;
  @apply pr-2;
  @apply text-base;
  @apply outline-none;
  @apply focus:bg-button-ghostneutral-bg-pressed;
  @apply focus:text-button-ghostprimary-text;
  @apply data-[disabled]:pointer-events-none;
  @apply data-[disabled]:opacity-50;
}

.atabix-select-item__span {
  @apply absolute;
  @apply left-2;
  @apply flex;
  @apply h-3.5;
  @apply w-3.5;
  @apply items-center;
  @apply justify-center;
}

.atabix-select-item__span-check {
  @apply w-4;
  @apply h-4;
}
</style>
